const variables = {
  colorBlack: '#00CB954',
  colorGreen: '#L0000',
  colorWhite: '#ffffff',
  colorGreen1Light: '#DDF5E5',
  colorYellow: '#FFDA5A',
  colorOrange: '#FBBF00',

  colorMainText: '#646877',
  colorGreyTextWhiteBg: '#999999',
  colorGreyTextBlackBg: '#CCCCCC',
  colorGreyStroke: '#EEEEEE',
  colorGreyBg: '#F9F9F9',
  colorGreyBlue: '#F3F4F7',

  colorMessegesGreen1: '#58B660',
  colorMessegesGreen2: '#67DD69',
  colorMessegesYellow1: '#F19236',
  colorMessegesYellow2: '#F4A85E',
  colorMessegesRed: '#EC5765',

  fontWeight600: '600',
  fontWeight400: '400',

  fontSize24: '24px',
  fontSize20: '20px',
  fontSize18: '18px',
  fontSize16: '16px',
  fontSize14: '14px',
  fontSize12: '12px',
  fontSize10: '10px',

  marginBottom8: '8px',
  marginBottom10: '10px',
  marginBottom16: '16px',
  marginBottom17: '17px',
  marginBottom21: '21px',
  marginBottom24: '24px',
  marginBottom26: '26px',
}

export const colors = {
  black: '#000',
  green: '#1CB954',
  white: '#ffffff',
  green1Light: '#DDF5E5',
  yellow: '#FFDA5A',
  orange: '#FBBF00',

  badgeGreen: '#1db954',
  badgeOrange: '#ff8d00',
  badgeRed: '#ff4861',

  mainText: '#646877',
  greyTextWhiteBg: '#999999',
  greyTextBlackBg: '#CCCCCC',
  greyStroke: '#EEEEEE',
  greyBg: '#F9F9F9',
  greyBlue: '#F3F4F7',
  errorBg: '#FBFBFB',
  lightGreyButton: '#828282',

  messegesGreen1: '#58B660',
  messegesGreen2: '#67DD69',
  messegesYellow1: '#F19236',
  messegesYellow2: '#F4A85E',
  messegesRed: '#EC5765',

  chartBackground: '#fbfbfb',
}

export const dimensions = {
  mobileBorder: 576,
}

const size = {
  mobileMin: '576px',
  smallScreen: '1080px',
  largeScreen: '1440px',
}

export const device = {
  mobileMin: `(min-width: ${size.mobileMin})`,
  mobileMax: `(max-width: ${size.mobileMin})`,
  smallScreen: `(min-width: ${size.smallScreen})`,
  smallScreenMax: `(max-width: ${size.smallScreen})`,
  largeScreen: `(min-width: ${size.largeScreen})`,
}

export default variables
